import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Spin } from 'antd';
import { Fade } from 'react-awesome-reveal';
import InvestorProfileLegal from './InvestorProfileLegal';
import form from '../../../../../../utils/form';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';
import FormInvestorProfile from './FormInvestorProfile';
import FormInvestorProfileResume from './FormInvestorProfileResume';


const InvestorLegalSurveyResult = ({ profileForm, investorProfile, onFinish, validateProfile, productos }) => {
  const { enrollmentForm, currentStepIndex } = useContext(EnrollmentContext);
  const initialValues = enrollmentForm[`step${currentStepIndex}`];
  const [isConfirmed, setConfirmed] = useState(initialValues?.confirmedProfile);
  const [selectProducts, setSelectProducts] = useState('');
  const [ShowResume, setShowResume] = useState(false);
  const toggleConfirmation = () => setConfirmed(!isConfirmed);
  const [isLoading, setLoading] = useState(false);

  const handleResume = (selectedProducts) => {
    setSelectProducts(selectedProducts);
    setShowResume(true);
    setLoading(false);
  };

  const goResumen = () => {
    const prod = profileForm.getFieldValue('products');
    profileForm.validateFields();
    if (prod) handleResume(profileForm.getFieldValue('products'));
  };

  return (
    <Fade>
      <Form
        onFinish={() => onFinish({ products: profileForm.getFieldValue('products') })}
        form={profileForm}
        preserve
        initialValues={initialValues}
        validateMessages={form.validateMessages}
        layout="vertical"
      >
        {ShowResume ? (
          <>
            <Spin spinning={isLoading}>
              <FormInvestorProfileResume selectProducts={selectProducts} />
            </Spin>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Continuar
              </Button>
            </Form.Item>
          </>



        ) : (
          <>
            <p>
              <b>Tu perfil de inversionista es:</b>
            </p>
            <InvestorProfileLegal
              isConfirmed={isConfirmed}
              profile={investorProfile}
              onConfirmToggle={toggleConfirmation}
            />
            <FormInvestorProfile validateProfile={validateProfile} productos={productos} />
            <Button type="primary" onClick={goResumen}>
              Continuar
            </Button>
          </>
        )}


      </Form>
    </Fade>
  );
};

InvestorLegalSurveyResult.propTypes = {
  investorProfile: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,

  onFinish: PropTypes.func.isRequired,
  profileForm: PropTypes.shape().isRequired,
  validateProfile: PropTypes.func.isRequired,
  productos: PropTypes.shape().isRequired,
};

export default InvestorLegalSurveyResult;
